<style scoped>
    .selectize-spinner {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0%;
        left: 0%;
    }
</style>
<template>
    <div style="position:relative">
        <div class="selectize-spinner">
            <selectize :options="options"
                       v-model="controller.value"
                       labelField="name"
                       valueField="id"
                       searchField="name">
            </selectize>
        </div>
    </div>
</template>
<script>
    import selectize from "./../../corecontrols/selectize/selectize.scp.html"
    import { ReorderOptionDto } from './../../../dto/ReorderOptionDto'
    import Dal from './../../../scripts/dataaccess'
    import { OrderStatus } from "./../../../dto/OrderStatusEnum"

    export default {
        //controler : FormElementController<
        props: [ 'controller' ],
        data: function () {
            return {
                options: {
                    allowEmptyOption: false,
                }
            }
        },
        mounted: function () {
            var dal = new Dal();
            this.options = dal.GetReorderOptions();
            if (!this.controller.value) {
                this.controller.value = this.options[0];
            }
        },
        components: {
            selectize
        }
    }
</script>


// WEBPACK FOOTER //
// drugStatusSelector.scp.html?6fd9ac7f